var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertSoftwareDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_5922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.418 14.6667L19.0013 19.25L14.418 23.8334",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.502 20.1667H31.8353",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9173 3.66669H3.41732C2.4048 3.66669 1.58398 4.4875 1.58398 5.50002V38.5C1.58398 39.5125 2.4048 40.3334 3.41732 40.3334H41.9173C42.9298 40.3334 43.7506 39.5125 43.7506 38.5V5.50002C43.7506 4.4875 42.9298 3.66669 41.9173 3.66669Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1686 7.33331H6.16862C5.66236 7.33331 5.25195 7.74372 5.25195 8.24998V35.75C5.25195 36.2562 5.66236 36.6666 6.16862 36.6666H39.1686C39.6749 36.6666 40.0853 36.2562 40.0853 35.75V8.24998C40.0853 7.74372 39.6749 7.33331 39.1686 7.33331Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_5922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0.667969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/expert_software_development.c7999e6fd44f3e25aa86a8f2ad6ac354.svg";
export { ForwardRef as ReactComponent };